export default "__VITE_ASSET__DmVlrTcF__"